import React from 'react';

// Reusable labelled field wrapper + controlled text/select inputs for the
// pre-onboarding form. Styling lives in PreOnboarding.css (preob-* classes).

export const Field = ({ label, required, htmlFor, children, hint, error }) => (
  <div className="preob-field">
    <label htmlFor={htmlFor} className="preob-field__label">
      {label}
      {required && <span className="preob-field__req">*</span>}
    </label>
    {children}
    {error ? (
      <p className="preob-field__error">{error}</p>
    ) : (
      hint && <p className="preob-field__hint">{hint}</p>
    )}
  </div>
);

export const TextInput = ({
  id,
  value,
  onChange,
  placeholder,
  type = 'text',
  required,
  inputMode,
  maxLength,
  invalid,
}) => (
  <input
    id={id}
    type={type}
    value={value}
    required={required}
    placeholder={placeholder}
    inputMode={inputMode}
    maxLength={maxLength}
    onChange={(e) => onChange(e.target.value)}
    className={`preob-input${invalid ? ' preob-input--invalid' : ''}`}
    aria-invalid={invalid || undefined}
  />
);

export const SelectInput = ({ id, value, onChange, required, children, invalid }) => (
  <select
    id={id}
    value={value}
    required={required}
    onChange={(e) => onChange(e.target.value)}
    className={`preob-input preob-input--select${invalid ? ' preob-input--invalid' : ''}`}
    aria-invalid={invalid || undefined}
  >
    {children}
  </select>
);
